import BenevvTextField from "components/forms/BenevvTextField/BenevvTextField";
import { ToolTip } from "../../ToolTip/ToolTip";
import * as ToolTipData from "../../ToolTip/ToolTipData";
import BenevvDropDown from "components/forms/BenevvDropDown/BenevvDropDown";
import CreateOrganizationcss from "../../CreateOrgMain/CreateOrganization.module.css";
import { StyleSpan } from "./BusinessIdentification.styles";
import { registrationStatus } from "../../DropDownData/DropDownData";

interface BusinessIdentification {
  setDnb: (v: string) => void;
  setNtee: (field: any) => void;
  setEin: (v: string) => void;
  setGeoArea: (field: any) => void;
  setRegesiterNum: (v: string) => void;
  setLegalOrgName: (field: any) => void;
  setStatus: (field: any) => void;
}

const StackedField = ({ label, children }: { label: React.ReactNode; children: React.ReactNode }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 0',
    minWidth: 220,
    maxWidth: '100%',
    marginBottom: 0
  }}>
    <label style={{ color: '#fe2f67', fontSize: '1.05rem', marginBottom: 6, whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}>{label}</label>
    {children}
  </div>
);

export function BusinessIdentification(props: BusinessIdentification) {
  const {
    setDnb,
    setNtee,
    setEin,
    setGeoArea,
    setRegesiterNum,
    setLegalOrgName,
    setStatus,
  } = props;

  return (
    <>
      <h2 className={CreateOrganizationcss.sectionHeader}>
        4. Business Identification
      </h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem' }}>
        <StackedField label={"Legal Name of Organization Name"}>
          <BenevvTextField
            styleInput={{ width: "100%", minHeight: "3rem", height: "3rem", maxHeight: "3rem", boxSizing: "border-box" }}
            htmlFor={"Legal Name of Organization Name"}
            placeholder={"Enter legal name of organization"}
            required={true}
            setTextField={setLegalOrgName}
            maxLength={100}
          />
        </StackedField>
        <StackedField label={"Registration Status"}>
          <BenevvDropDown
            styleDropDown={{ width: "100%", minHeight: "3rem", height: "3rem", maxHeight: "3rem", boxSizing: "border-box" }}
            label=""
            placeholder="Select registration status"
            setTextField={setStatus}
            values={registrationStatus}
          />
        </StackedField>
        <StackedField label={"Registration Number (9 digits)"}>
          <BenevvTextField
            styleInput={{ width: "100%", minHeight: "3rem", height: "3rem", maxHeight: "3rem", boxSizing: "border-box" }}
            htmlFor={"Registration Number"}
            placeholder={"Enter registration number"}
            required={true}
            numeric={true}
            setTextField={setRegesiterNum}
            maxLength={9}
          />
        </StackedField>
        <StackedField label={"Geographic Area Served by Organization"}>
          <BenevvTextField
            styleInput={{ width: "100%", minHeight: "3rem", height: "3rem", maxHeight: "3rem", boxSizing: "border-box" }}
            htmlFor={"Geographic Area Served by Organization"}
            placeholder={"Enter geographic area"}
            required={true}
            setTextField={setGeoArea}
          />
        </StackedField>
        {/* EIN, NTEE, DNB in a single row */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem', marginBottom: '1.5rem' }}>
          <StackedField label={<StyleSpan>EIN (9 digits) <ToolTip toolTipData={ToolTipData.einContent} /></StyleSpan>}>
            <BenevvTextField
              styleInput={{ width: "100%", minHeight: "3rem", height: "3rem", maxHeight: "3rem", boxSizing: "border-box" }}
              htmlFor="ein"
              placeholder="Enter EIN number"
              required
              numeric={true}
              maxLength={9}
              setTextField={setEin}
            />
          </StackedField>
          <StackedField label={<StyleSpan>NTEE Code <span className={CreateOrganizationcss.optional} style={{ paddingLeft: ".3em" }}>(Optional)</span> <ToolTip toolTipData={ToolTipData.nteeCodeContent} /></StyleSpan>}>
            <BenevvTextField
              styleInput={{ width: "100%", minHeight: "3rem", height: "3rem", maxHeight: "3rem", boxSizing: "border-box" }}
              htmlFor="ntee"
              placeholder="e.g. S99"
              required={false}
              maxLength={5}
              setTextField={setNtee}
            />
          </StackedField>
          <StackedField label={<StyleSpan>DNB Number <span className={CreateOrganizationcss.optional} style={{ paddingLeft: ".3em" }}>(Optional) 9 digits</span> <ToolTip toolTipData={ToolTipData.dnbNumberContent} /></StyleSpan>}>
            <BenevvTextField
              styleInput={{ width: "100%", minHeight: "3rem", height: "3rem", maxHeight: "3rem", boxSizing: "border-box" }}
              htmlFor="dnb"
              placeholder="Enter DNB number"
              required={false}
              numeric
              maxLength={9}
              setTextField={setDnb}
            />
          </StackedField>
        </div>
      </div>
    </>
  );
}
